import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { TextField } from 'material-ui';

import ReactTable from "react-table";
import axios from 'axios/index';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';

const styles = theme => ({
    layoutRoot: {}
});

class ReceiptView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: [],
        }
        this.getAllReceipts();
    }

    // get all receipt data
    getAllReceipts() {
        this.state.loading = true;
        var data = [];

        axios.get(window.salesServer + '/receipt/getAllReceipt')
            .then(response => {

                if (response.data.success) {

                    var receiptData = response.data.result;
                    for (var i = 0; i < receiptData.length; i++) {
                        data.push({
                            invoiceHeaderID: receiptData[i].ID_INVOICE_HEADER,
                            invoiceRef: receiptData[i].REFERENCE_NO,
                            receiptRef: receiptData[i].RECEIPT_REFERNCE_NO,
                            customerName: receiptData[i].CUSTOMER_NAME,
                            lateCharge: receiptData[i].LATE_PAYMENT_CHARGE,
                            grossAmount: receiptData[i].GROSS_AMOUNT,
                            netAmount: receiptData[i].NET_AMOUNT,
                            outstanding: receiptData[i].OUTSTANDING,
                            dev: receiptData[i].DEV_AMOUNT,
                            pay: receiptData[i].PAYMENT,
                            paymentTerm: (receiptData[i].PAYMENT_TERM_NET) ? receiptData[i].PAYMENT_TERM_NET.toString().split('T')[0] : '',
                            billDate: (receiptData[i].BILL_DATE) ? receiptData[i].BILL_DATE.toString().split('T')[0] : '',
                        });
                    }

                    this.setState({
                        data: data,
                        loading: false
                    });
                }
            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
            });
    }

    handleSearchAny = (e) => {
        var value = e.target.value;
        // this.setState({ loading: true });

        var searchObj = {
            searchVal: value,
        }

        var data = [];
        axios.post(window.salesServer + '/receipt/searchReceipt', searchObj)
            .then(response => {

                if (response.data.success) {
                    var receiptData = response.data.result;
                    for (var i = 0; i < receiptData.length; i++) {
                        data.push({
                            invoiceHeaderID: receiptData[i].ID_INVOICE_HEADER,
                            invoiceRef: receiptData[i].REFERENCE_NO,
                            receiptRef: receiptData[i].RECEIPT_REFERNCE_NO,
                            customerName: receiptData[i].CUSTOMER_NAME,
                            lateCharge: receiptData[i].LATE_PAYMENT_CHARGE,
                            grossAmount: receiptData[i].GROSS_AMOUNT,
                            netAmount: receiptData[i].NET_AMOUNT,
                            outstanding: receiptData[i].OUTSTANDING,
                            dev: receiptData[i].DEV_AMOUNT,
                            pay: receiptData[i].PAYMENT,
                            paymentTerm: (receiptData[i].PAYMENT_TERM_NET) ? receiptData[i].PAYMENT_TERM_NET.toString().split('T')[0] : '',
                            billDate: (receiptData[i].BILL_DATE) ? receiptData[i].BILL_DATE.toString().split('T')[0] : '',
                        });
                    }

                    this.setState({
                        data: data,
                        loading: false
                    });
                }

            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
            });
    }

    onPrint = (receiptRef) => {
        var address = null;
        axios.get(window.reportServer + '/report/get/reciept', {
            // axios.get('http://localhost:5008/report/get/reciept', {
            params: {
                refId: receiptRef
            }
        }).then(response => {
            address = response.data.path;
            address = window.reportServer + "/" + address;

            //alert(address);
            //this.setState({ address: address });

            const url = address;
            window.open(url, '_blank');

        });
    }

    render() {

        var columns = [
            {
                Header: "ID_INVOICE_HEADER",
                accessor: "invoiceHeaderID",
                className: "justify-center",
                show: false
            },
            {
                Header: "Invoice Ref",
                accessor: "invoiceRef",
                className: "justify-center",

            },
            {
                Header: "Receipt Ref",
                accessor: "receiptRef",
                className: "justify-center",

            },
            {
                Header: "Customer",
                className: "justify-center",
                accessor: "customerName"

            },
            {
                Header: "Late Charge",
                className: "justify-center",
                accessor: "lateCharge"

            },
            {
                Header: "Gross",
                className: "justify-center",
                accessor: "grossAmount"

            },
            {
                Header: "Net",
                className: "justify-center",
                accessor: "netAmount"

            },
            {
                Header: "Outstanding",
                className: "justify-center",
                accessor: "outstanding"

            },
            // {
            //     Header: "Dev",
            //     className: "justify-center",
            //     accessor: "dev"

            // },
            {
                Header: "Pay",
                className: "justify-center",
                accessor: "pay"

            },
            {
                Header: "Payment Term (Date)",
                className: "justify-center",
                accessor: "paymentTerm"

            },
            {
                Header: "Bill Date",
                className: "justify-center",
                accessor: "billDate"

            },
            {
                Header: "Action",
                width: 128,
                Cell: row => (
                    <div className="flex items-center w-8 h-8">
                        <IconButton

                            onClick={(e) => {
                                console.log(row.original)
                                if (row) {
                                    this.onPrint(row.original.receiptRef)
                                }
                            }}

                        >
                            <Icon className="text-blue">print</Icon>
                        </IconButton>

                    </div>
                )
            }
        ]

        if (this.state.loading) {
            return (<Loader />);
        } else {

            return (
                <div>
                    <div className="subtitle-color p-20">
                        <h2>Receipt View</h2>
                    </div>

                    <div className="w-full md:w-1/3">
                        <TextField
                            placeholder="Search for anything"
                            className="pl-16"
                            fullWidth
                            value={this.state.value}
                            inputProps={{
                                'aria-label': 'Search'
                            }}
                            onChange={this.handleSearchAny}
                        />
                    </div><br></br>

                    <div class="w-full bg-white h-auto">
                        <ReactTable
                            getTrProps={(state, rowInfo, column) => {
                                return {
                                    className: "cursor-pointer",
                                    onClick: (e, handleOriginal) => {

                                    }
                                }
                            }}
                            data={this.state.data}
                            columns={columns}
                            defaultPageSize={10}
                            className="-striped -highlight"
                        />
                    </div>

                </div>
            )
        }
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(ReceiptView));


// WEBPACK FOOTER //
// ./src/main/content/sales/receipt/receiptView.js